/* PileViewerReact specific styles */
/* Note: Card grid item styles have been moved to CardGridItemReact.module.css */
